import React from "react";
import Chip from "@mui/material/Chip";
import StarIcon from "@mui/icons-material/Star";
import { styled } from "@mui/material/styles";
import { useAuth } from "../../contexts/AuthContext";
import { Badge } from "@mui/material";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
    borderRadius: "50%",
    minWidth: "10px",
    height: "10px",
    padding: "0.5px",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    marginLeft: 3,
  },
}));

export default function UserRoleChip() {
  const { isAdmin, isFullAccessAdmin } = useAuth();

  const label = isAdmin ? "Admin" : "User";

  return isAdmin && isFullAccessAdmin ? (
    <StyledBadge
      overlap="circular"
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      badgeContent={<StarIcon style={{ fontSize: 9 }} />}
    >
      <Chip label={label} size="small" />
    </StyledBadge>
  ) : (
    <Chip label={label} size="small" />
  );
}
